<template>
  <div>
    <PageHeader :title="title" :items="items" />

    <!-- filters -->
    <ViewModel :id="id" :obj="obj" @accept="accept" @deny="deny" />

    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <div class="row"> </div>

          <b-tabs>
            <b-tab
              active
              title="Aguardando aprovação"
              @click="changeTabs('REQUESTED')"
            >
            </b-tab>
            <b-tab title="Aprovados" @click="changeTabs('APPROVED')"> </b-tab>

            <b-tab title="Desaprovados" @click="changeTabs('DISAPPROVED')"> </b-tab>

          </b-tabs>

          <!-- Table -->
          <div class="row">
            <div class="col-12">
              <div class="d-flex">
                <b-button variant="dark" class="mb-2" @click="fetchIdentitys"
                  >Recarregar</b-button
                >

                <!-- Search -->
                <div class="col-sm-12 col-md-11">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-right"
                  >
                    <label class="d-inline-flex align-items-center">
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Pesquise pelo e-mail"
                        class="form-control form-control-sm ml-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>

              <div v-if="analysis.length > 0" class="table-responsive mb-0">
                <b-table
                  :items="analysis"
                  :fields="columns"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  sort-icon-left
                  :filter-included-fields="filterOn"
                >
                  <!-- E-mail -->
                  <template v-slot:[`cell(user.email)`]="data">
                    <div class="externclass">
                      <div
                        class="classification"
                        :style="setColor(data.item.user.classification)"
                      ></div>
                      <p>{{ data.item.user.email }}</p>
                    </div>
                  </template>
                  <!-- Create At -->
                  <template v-slot:cell(created_at)="data">
                    {{ data.value | datetime }}
                  </template>
                  <!-- Poses -->
                  <template v-slot:cell(poses)="row">
                    <b-button
                      variant="primary"
                      class="mr-2"
                      @click="open(row.item)"
                    >
                      <i class="fas fa-eye"></i>
                    </b-button>
                  </template>
                  <!-- Status -->
                  <template v-slot:cell(_status)="data">
                    {{ getStatus(data.item.status) }}
                  </template>
                  <!-- Actions -->
                  <template v-slot:cell(_actions)="data">
                    <div v-if="!showToAdminFinancial">
                      
                      <b-button
                        v-if="(!data.item.analysed && statusDocs === 'REQUESTED' ) || statusDocs === 'DISAPPROVED'"
                        variant="success"
                        class="mr-2"
                        @click="accept(data.item.id)"
                      >
                        <i class="fas fa-check"></i>
                      </b-button>

                      <b-button
                        v-if="!data.item.analysed && statusDocs !== 'DISAPPROVED'"
                        variant="danger"
                        class="mr-2"
                        @click="deny(data.item.id)"
                      >
                        <i class="fas fa-times"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <!-- Loading -->
          <div v-if="loading" class="row justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <!-- Feedback Message -->
          <div v-if="analysis.length === 0" class="row justify-content-center">
            <div class="alert alert-primary" role="alert">
              Sem requisições pendentes.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import appConfig from '@src/app.config'
import PageHeader from '@components/page-header'
import IdentityService from '@services/resources/IdentityService'
import Money from '@src/mixins/money'
import ViewModel from '@components/identity/view'
import _ from 'lodash'
import validAcessRoute from '@/src/utils/validAcessRoute'
var service = IdentityService.build()

export default {
  name: 'IdentityList',
  page: {
    title: 'Validação de Identidades',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { PageHeader, ViewModel },
  mixins: [Money],
  data() {
    return {
      title: 'Validação de Identidades',
      id: 0,
      analysis: [],
      solicitation: {},
      loading: true,
      showToAdminFinancial: validAcessRoute(
        ['financial'],
        this.$store.getters.getProfile
      ),
      items: [
        {
          text: 'Início',
          href: '/',
        },
        {
          text: 'Validação de Identidades',
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      total: 0,
      totalToPaid: 0,
      perPage: 20,
      pageOptions: [20, 50, 100],
      filter: '',
      filterOn: [],
      filters: {},
      sortBy: 'name',
      sortDesc: false,
      statusDocs: 'REQUESTED',

      columns: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'poses', label: 'Visualizar', sortable: false },
        { key: 'user.email', label: 'E-mail', sortable: false },
        { key: '_status', label: 'Status', sortable: false },
        { key: 'created_at', label: 'Data', sortable: false },
        { key: '_actions', label: 'Ações', sortable: false },
      ],
      obj: {
        poses: '["BLINK", "TURN_RIGHT", "LOOK_UP"]',
      },
    }
  },
  watch: {
    currentPage() {
      this.fetchIdentitys()
    },
    perPage() {
      this.fetchIdentitys()
    },
    filter() {
      this.debounce()
    },
  },
  mounted() {
    this.fetchIdentitys()
  },
  methods: {
    debounce: _.debounce(function () {
      this.fetchIdentitys()
    }, 500),
    changeTabs(e) {
      this.statusDocs = e

      this.fetchIdentitys()
    },
    getStatus(status) {
      let newStatus = ''
      switch (status.toUpperCase()) {
        case 'APPROVED':
          newStatus = 'Aprovado'
          break
        case 'DISAPPROVED':
          newStatus = 'Recusado'
          break
        case 'REQUESTED':
          newStatus = 'Aguardando Análise'
          break
      }
      return newStatus
    },
    setColor(type) {
      switch (type) {
        case 'greenn': return 'background: #00E4A0'
        case 'yellow': return 'background: #fff700'
        case 'red': return 'background: #FF0A44'
        case 'black': return 'background: #000000'
        default: return 'background:#c7c7c7;'
      }
    },
    fetchIdentitys() {
      this.loading = true
      this.analysis = []

      let data = {
        status: this.statusDocs,
      }

      if (this.filter.length) data.email = this.filter

      service
        .search(data)
        .then((resp) => {
          this.analysis = resp.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    update(data) {
      service
        .update(data)
        .then(() => {
          let myArray = this.analysis
          let cutID = parseInt(data.id.split('/', 2)[1])
          let index = myArray.findIndex((el) => el.id === cutID)
          this.analysis.splice(index, 1)
          this.$bvModal.hide('modal-view-identity')
          this.filter = ''
        })
        .catch(err => console.error(err))
    },
    accept(id) {
      Vue.swal({
        title: 'Análise',
        text: 'Tem certeza que deseja aprovar essa análise?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            id: 'analyse/' + id,
            status: 'APPROVED',
          }
          this.update(data)
        }
      })
    },
    deny(id) {
      Vue.swal({
        title: 'Análise',
        text: 'Tem certeza que deseja recusar essa análise?',
        type: 'warning',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off',
        },
        showCancelButton: true,
        confirmButtonText: 'Reprovar',
        cancelButtonText: 'Cancelar',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            id: 'analyse/' + id,
            status: 'DISAPPROVED',
            observation: result.value,
          }

          this.update(data)
        }
      })
    },
    open(obj) {
      this.id = obj.id
      this.obj = obj
      this.$bvModal.show('modal-view-identity')
    },
  },
}
</script>
